/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "25a122fc8b00d6e74bed1650effac99fe8854650";
